/* global NODE_ENV */
import React from 'react';
import {Comment} from 'FW/Models/Comment';
import { GoogleReCaptchaProvider, withGoogleReCaptcha } from 'react-google-recaptcha-v3';
import config from 'config';
import moment from 'moment';
let Validate;

class CommentForm extends React.Component {
  constructor(props) {
    super(...arguments);
    this.state = {
      name: '',
      email: '',
      content: '',
      receive_notifications: false,
      errors: {}
    };

    import('validatorjs').then((mod) => {
      Validate = mod.default;
    });

    this.postComment = this.postComment.bind(this);
    this.captchaChanged = this.captchaChanged.bind(this);
  }

  fieldUpdated(key, e) {
    let value = e.target.value;
    let state = {};
    state[key] = value;
    this.setState(state);
  }

  postComment = async () => {
    this.setState({
      submitting: true
    });
    let token =  await this.props.googleReCaptchaProps.executeRecaptcha('post_blog_comment');
    let {name, email, content, receive_notifications} = this.state;
    let user = FW.store.get('user');
    let parentUser = this.props.parent.get('user');
    let userId = user ? user.get('id') : null;
    let parentId = parentUser ? parentUser.get('id') : null;
    let parentComment =
      typeof this.props.parentComment !== 'undefined'
        ? this.props.parentComment
        : null;
    let data = {
      site_id: FW.store.get('site').get('id'),
      name: user ? (user.get('name') || 'Registered User') : name,
      email: user ? user.get('email') : email,
      content: content,
      parent_comment_id: parentComment ? parentComment.get('id') : null,
      page_section_id: this.props.section ? this.props.section.get('id') : null,
      commentable_id: this.props.parent.get('id'),
      commentable_type: this.props.parent.defaults.type,
      receive_notifications: receive_notifications,
      created_at: moment.utc().format('Y-MM-DD HH:mm:ss'),
      'g-recaptcha-response': token,
      user_id: userId,
      user: user,
      approved_at: null
    };

    let rules = {
      name: 'required',
      email: 'required|email',
      content: 'required|string',
      site_id: 'required'
    };

    if (NODE_ENV === 'production') {
      rules['g-recaptcha-response'] = 'required';
    }

    let validator = new Validate(data, rules);
    validator.setAttributeNames({
      'g-recaptcha-response': 'captcha'
    });

    if (validator.fails()) {
      this.setState({
        errors: validator.errors.all()
      });
      return;
    }

    let comment = new Comment(data);
    let siteId = FW.store.get('site').get('id');
    let collection;
    if (siteId !== null) {
      if (!parentComment) {
        collection = this.props.parent.get('comments');
      } else {
        collection = parentComment.get('comments');
      }
      let addFunction;
      //if the post doesn't require approval or the poster is the author of the blog.
      if (
        !this.props.parent.requireCommentApproval ||
        (userId === parentId && userId !== null)
      ) {
        collection.add(comment);
        addFunction = this.props.onAdd;
      } else {
        addFunction = this.props.onAddNeedingApproval;
      }
      comment.save(
        {},
        {
          success: (d, r) => {
            if (r.success === false) {
              collection.remove(comment);
              this.setState({
                errors: r.errors
              });
            } else {
              comment.get('comments').parentId = comment.get('id');
              this.setState({
                name: '',
                email: '',
                content: ''
              });
              if (addFunction) {
                //we don't need the captcha response on the model.
                comment.unset('g-recaptcha-response');
                addFunction(comment);
              }
            }
          }
        }
      );
    }
  };

  captchaChanged(value) {
    this.setState({
      captchaValue: value
    });
  }

  receiveNotificationChanged = (e) => {
    this.setState({
      receive_notifications: !this.state.receive_notifications
    });
  }

  render() {
    let user = FW.store.get('user');
    let nameClass =
      'form-group col-md-6 ' + (this.state.errors.name ? 'has-error' : '');
    let emailClass =
      'form-group col-md-6 ' + (this.state.errors.email ? 'has-error' : '');
    let contentClass =
      'form-group col-md-12 ' + (this.state.errors.content ? 'has-error' : '');
    let recaptchaClass =
      'form-group col-md-12 ' +
      (this.state.errors['g-recaptcha-response'] ? 'has-error' : '');
    return (
      <div className="row">
        {typeof user === 'undefined' ? (
          <div>
            <div className={nameClass}>
              <label>Name</label>
              <input
                className="form-control"
                name="name"
                value={this.state.name}
                onChange={this.fieldUpdated.bind(this, 'name')}
              />
              {this.state.errors.name ? (
                <span className="help-block">{this.state.errors.name[0]}</span>
              ) : null}
            </div>
            <div className={emailClass}>
              <label>Email Address</label>
              <input
                className="form-control"
                name="email"
                value={this.state.email}
                onChange={this.fieldUpdated.bind(this, 'email')}
              />
              {this.state.errors.email ? (
                <span className="help-block">{this.state.errors.email[0]}</span>
              ) : <span>Email address will not be publicly visible.</span>}
            </div>
          </div>
        ) : null}
        <div className={contentClass}>
          <label>Comment</label>
          <textarea
            className="form-control"
            name="content"
            rows="3"
            value={this.state.content}
            onChange={this.fieldUpdated.bind(this, 'content')}
          ></textarea>
          {this.state.errors.content ? (
            <span className="help-block">{this.state.errors.content[0]}</span>
          ) : null}
        </div>
        <div className="col-md-12">
          <div className="checkbox">
            <label><input type="checkbox" name="receive_notifications" checked={this.state.receive_notifications} onChange={this.receiveNotificationChanged} /> Receive reply notifications</label>
          </div>
        </div>
        <div className="col-md-12">
          <div className="row">
            <div className={recaptchaClass}>
              {this.state.errors['g-recaptcha-response'] ? (
                <span className="help-block has-error">
                    {this.state.errors['g-recaptcha-response'][0]}
                  </span>
              ) : null}
            </div>
          </div>
          <div className="comment-buttons">
            <span
              className={this.state.submitting ? 'btn btn-primary disabled' : "btn btn-primary"}
              id="postCommentButton"
              onClick={this.postComment}
            >
              {this.state.submitting ? 'Submitting...' : 'Post Comment'}
            </span>
            <div style={{color: '#bec0c1', fontSize: 12, maxWidth: 300, margin: 'auto', padding: 5}}>
              This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const RecaptchaCommentForm = withGoogleReCaptcha(CommentForm);

export default function(props) {
  return <GoogleReCaptchaProvider reCaptchaKey={config.RECAPTCHA3_PUBLIC_KEY}>
    <RecaptchaCommentForm {...props} />
  </GoogleReCaptchaProvider>;
}
